import React from "react";
import BG from "../../images/icons/sectionbackground.png";

const HowWorks = ({ title, titleClass, obj }) => {
  return (
    <div className="w-full flex flex-col items-center justify-center py-12 px-4 md:px-8 relative">
      {/* Background Image */}
      <img
        src={BG}
        alt="background"
        className="absolute inset-0 w-full h-full object-cover rounded-lg opacity-20"
      />

      {/* Centered Container with max-width for better responsiveness */}
      <div className="relative w-full max-w-7xl mx-auto flex flex-col gap-12 items-center justify-center text-center z-10">
        {/* Title */}
        <h2
          className={`${titleClass} text-3xl md:text-4xl lg:text-5xl font-bold`}
        >
          {title}
        </h2>

        {/* Cards Section - Simplified and fixed grid layout */}
        <div className="w-full max-w-screen-xl mx-auto">
          <div
            className={`grid grid-cols-1 gap-6 md:gap-8 
            ${
              obj.length === 1
                ? "md:grid-cols-1 max-w-md mx-auto"
                : obj.length === 2
                ? "md:grid-cols-2 max-w-2xl mx-auto"
                : obj.length === 3
                ? "md:grid-cols-3 max-w-4xl mx-auto"
                : "md:grid-cols-2 lg:grid-cols-4"
            }`}
          >
            {obj.map((item) => (
              <div
                key={item.id}
                className="relative bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center justify-center p-6"
              >
                {/* Half Circle in Top Left Corner */}
                <div className="absolute -top-4 -left-4 bg-custom-gradient w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-md md:text-lg">
                    {item.id}
                  </span>
                </div>

                {/* Card Content */}
                <div className="flex justify-center">
                  <img
                    src={item.icon}
                    alt={`${item.heading} icon`}
                    className="h-10 w-10 md:h-12 md:w-12 shadow-xl"
                  />
                </div>
                <div className="text-center mt-6">
                  <h3 className="text-lg md:text-xl font-semibold text-black">
                    {item.heading}
                  </h3>
                  <p className="text-gray-600 mt-2 text-sm md:text-base">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowWorks;
